(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bos-sale-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bos-sale-countdown')) {
  customElements.define('bos-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      this.newsletter = this.querySelector('[data-newsletter]');
      this.terms = this.querySelector('[data-terms]');
      this.querySelector('[data-open-terms]')?.addEventListener('click', () => this.terms.showModal());
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }));
      if (!Number.isFinite(this.start) || !Number.isFinite(this.end)) return;
      this.update();
      if (this.hidden) return;
      this.interval = setInterval(() => this.update(), 1000);
      let seen = false;
      try { seen = sessionStorage.getItem('bos-newsletter-1111-seen') === '1'; } catch (error) {}
      const formResult = this.querySelector('[data-signup-success], [data-signup-error]');
      if (formResult || (!seen && this.dataset.subscribed !== 'true')) {
        this.popupFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.hidden || this.newsletter.open) return;
          this.newsletter.showModal();
          try { sessionStorage.setItem('bos-newsletter-1111-seen', '1'); } catch (error) {}
        });
      }
    }
    disconnectedCallback() { clearInterval(this.interval); cancelAnimationFrame(this.popupFrame); this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()); }
    update() {
      const now = Date.now();
      if (now >= this.end) { this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()); this.hidden = true; clearInterval(this.interval); return; }
      const started = now >= this.start;
      this.querySelectorAll('[data-before]').forEach(node => { node.hidden = started; });
      this.querySelectorAll('[data-during]').forEach(node => { node.hidden = !started; });
      const seconds = Math.max(0, Math.ceil(((started ? this.end : this.start) - now) / 1000));
      const units = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [key, value] of Object.entries(units)) this.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
